import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { detectBrowserLanguage } from '../libs/language'
import { languageForCountry } from '../libs/countries'

// localStorage-Key, in dem die manuell im Dropdown gewählte
// Sprache abgelegt wird (siehe Language.jsx). Solange dieser Wert
// gesetzt ist, hat die Userwahl Vorrang vor URL-Country und Browser.
export const USER_LANG_PREF_KEY = 'userLangPref'

// Wechselt die i18next-Sprache automatisch passend zum URL-Country-Segment.
// Reihenfolge der Priorität:
//   1. Manuell im Dropdown gewählte Sprache (localStorage)
//   2. URL-Country (z.B. /BR/... -> pt-BR)
//   3. Browser-/OS-Sprache
export const useCountryLanguage = () => {
  const { country } = useParams()
  const { i18n } = useTranslation()

  useEffect(() => {
    const userPref = localStorage.getItem(USER_LANG_PREF_KEY)
    if (userPref) {
      if (i18n.language !== userPref) i18n.changeLanguage(userPref)
      return
    }
    const target = languageForCountry(country) || detectBrowserLanguage()
    if (i18n.language !== target) i18n.changeLanguage(target)
  }, [country, i18n])
}

export default useCountryLanguage
